function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "runner_icon_svg__a",
  d: "M1253.927 206.176c1.483 0 2.686-1.23 2.686-2.747 0-1.519-1.203-2.749-2.686-2.749-1.484 0-2.687 1.23-2.687 2.748 0 1.517 1.203 2.748 2.687 2.748z"
}), React.createElement("path", {
  id: "runner_icon_svg__b",
  d: "M1256.61 209.748h-3.937l-1.189-2.925a1.295 1.295 0 00-.204-.343l-.08-.097-2.66-3.228-2.345-2.847a1.275 1.275 0 00-.985-.468h-5.085c-.71 0-1.287.59-1.287 1.317s.576 1.317 1.287 1.317h4.486l1.422 1.726-5.622 5.435c-.13.09-.254.195-.367.316-.831.9-.793 2.32.085 3.17l4.36 4.219-5.658 1.387c-.7.171-1.133.892-.965 1.61a1.303 1.303 0 001.573.985l7.99-1.958a1.3 1.3 0 00.432-.196 1.349 1.349 0 00.337-1.848l-.08-.12-3.3-4.924 4.717-3.387 1.09 2.682c.2.492.668.812 1.19.812h4.795c.71 0 1.287-.59 1.287-1.317s-.576-1.318-1.287-1.318z"
}), React.createElement("path", {
  id: "runner_icon_svg__c",
  d: "M1239.044 214.303a3.866 3.866 0 01-1.162-2.473l-8.612 7.559a1.465 1.465 0 00-.197 1.972 1.385 1.385 0 001.973.257l8.557-6.773z"
}), React.createElement("path", {
  id: "runner_icon_svg__d",
  d: "M1240.884 205.653c0 .46-.364.832-.813.832h-6.637a.823.823 0 01-.814-.832c0-.46.364-.833.814-.833h6.636c.45 0 .814.372.814.833z"
}), React.createElement("path", {
  id: "runner_icon_svg__e",
  d: "M1237.834 208.773c0 .46-.364.832-.814.832h-6.636a.823.823 0 01-.814-.832c0-.46.364-.833.814-.833h6.636c.45 0 .814.372.814.833z"
}), React.createElement("path", {
  id: "runner_icon_svg__f",
  d: "M1234.785 211.893c0 .46-.365.832-.814.832h-6.637a.823.823 0 01-.814-.832c0-.46.364-.833.814-.833h6.636c.45 0 .815.372.815.833z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#runner_icon_svg__a",
  transform: "translate(-1226 -199)"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#runner_icon_svg__b",
  transform: "translate(-1226 -199)"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#runner_icon_svg__c",
  transform: "translate(-1226 -199)"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#runner_icon_svg__d",
  transform: "translate(-1226 -199)"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1226 -199)"
}, React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#runner_icon_svg__e"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1226 -199)"
}, React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#runner_icon_svg__f"
}));

var SvgRunnerIcon = function SvgRunnerIcon(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgRunnerIcon;